<ng-container *ngIf="!loading">
    <div #main [ngStyle]="{'height.px': height}" class="w-100"></div>
</ng-container>
<ng-container *ngIf="loading">
    <div [ngStyle]="{'height.px': height}" class="d-flex flex-column justify-content-center align-items-center">
        <div class="spinner-border" role="status" *ngIf="!option?.value">
            <span class="sr-only">Loading...</span>
        </div>
        <div *ngIf="option?.value">
            <h1 class="text-center">{{option?.value}}</h1>
        </div>
    </div>
</ng-container>
